import { useContext } from 'react';

import SeasonalCard from '@/components/game/ui/card/SeasonalCard';
import { GameContext, ViewContext } from '@/state/contexts';
import { performActionType } from '@/type/performAction';
import { getCardMetadata } from '@/util/card';
import { logg } from '@/util/logg';
import { recyclingPlant } from '@lc/const/modifiers';
import { playEquipmentById } from '@lc/const/socketEvent';
import { createActionParams } from '@lc/interface/actionParams/factory';

const CardPileEquipment = ({ title, cards, equipmentAction, playerId }) => {
	const { currPlayer, activePlayerId, myState, performAction }: any =
		useContext(GameContext); // numPlayers, monthTracker, seasonTracker, carbonReservoir,
	const { setShowCardTableModal }: any = useContext(ViewContext);
	if (cards.length <= 0) return;

	const performActionTyped = performAction as performActionType;

	function performEquipmentAction(e, cardId: number) {
		e.preventDefault();
		const actionParams = createActionParams(cardId);

		performActionTyped(playEquipmentById, actionParams);
		setShowCardTableModal(false);
	}

	/**
	 * Tests if an equipment card can be played.
	 *
	 * If an equipment's modifier IS NOT PRESENT on the player's modifier array, you can play it.
	 *
	 * when an equipment card with a discard is played, add the modifier to the player's modifier array
	 * until the next news card. then remove it. It is now playable
	 *
	 * for repeatable actions on equipment cards, modifier is added whenever card is played then
	 * removed at a set interval
	 * @param {*} pState player's state object
	 * @param {*} card
	 * @returns {boolean, boolean} {hasDiscardAction, hasRepeatableAction} each a boolaen
	 */
	function determineEquipmentModifiers(pState, card) {
		let hasDiscardAction = false;
		let hasRepeatableAction = false;

		if (
			currPlayer.playerId !== playerId ||
			activePlayerId !== currPlayer.playerId
		) {
			logg('reeeturn');
			return { hasDiscardAction, hasRepeatableAction };
		}

		const modifiers = pState?.modifiers || [];

		logg('modifiers');
		logg(modifiers);
		logg(typeof modifiers);
		logg(pState.modifiers.length);

		if (modifiers.length === 0) {
			hasDiscardAction = card.hasDiscardAction;
			hasRepeatableAction = card.hasRepeatableAction;
		}

		if (modifiers.length > 0 && !modifiers.includes(card.modifier)) {
			hasDiscardAction = card.hasDiscardAction;
			hasRepeatableAction = card.hasRepeatableAction;
		}

		return { hasDiscardAction, hasRepeatableAction };
	}

	function equipmentButton(btnTxt, cardId) {
		return (
			<button
				value={0}
				onClick={(e) => performEquipmentAction(e, cardId)}
			>
				{btnTxt}
			</button>
		);
	}

	function recyclingEquipmentButton(btnTxt, cardId) {
		return (
			<button value={0} onClick={(e) => equipmentAction(e, cardId)}>
				{btnTxt}
			</button>
		);
	}

	function equipmentCardGenerator(cardId: number) {
		const card = getCardMetadata(cardId);
		logg('determineEquipmentModifiers');
		let { hasDiscardAction = false, hasRepeatableAction = false } =
			determineEquipmentModifiers(myState, card);
		logg(
			`hasDiscardAction: ${hasDiscardAction}. hasRepeatableAction: ${hasRepeatableAction}`
		);

		if (card.modifier === recyclingPlant) {
			return (
				<div className="card" key={cardId}>
					<SeasonalCard cardId={cardId} width={0} height={0} />
					{hasRepeatableAction &&
						recyclingEquipmentButton('Use Card', cardId)}
				</div>
			);
		}

		return (
			<div className="card" key={cardId}>
				<SeasonalCard cardId={cardId} width={0} height={0} />
				{hasDiscardAction && equipmentButton('Discard Card', cardId)}
				{hasRepeatableAction && equipmentButton('Use Card', cardId)}
			</div>
		);
	}

	// TODO add 'discard' button to equipment
	// Either 'discard' or some other kind of button that is revealed or hidden depending on card presence & player modifiers
	return (
		<div>
			<h2>{title}</h2>
			<div className="hand">
				{cards.map((cardId: number) => equipmentCardGenerator(cardId))}
			</div>
		</div>
	);
};

export default CardPileEquipment;
